import {Loader} from '@mantine/core'
import {Body, TableNode} from '@table-library/react-table-library'
import {Sort as SortData} from '@table-library/react-table-library/types/sort'
import React from 'react'
import {DataTableContentRow} from './content-row'
import {DataTableHeaderRow} from './header-row'
import {
  DataTableColumnInfo,
  DataTableFiltersData,
  DataTableInteractiveRowsData,
  DataTableSummaryRowProps,
} from '../model'
import {DataTableSelectContext} from '../hooks/use-row-select'

export interface DataTableContentProps<ColumnID extends string, ITEM extends TableNode> {
  rows: Array<ITEM>,
  columns: Array<DataTableColumnInfo<ColumnID, ITEM>>
  loading?: boolean,
  select?: DataTableSelectContext,
  sort?: SortData,
  filtersData?: DataTableFiltersData<ColumnID>,
  getShortcutActions?: (item: ITEM) => JSX.Element,
  interactiveRowsData?: DataTableInteractiveRowsData<ITEM>,
  onRowDoubleClick?: (row: ITEM) => void,
  summaryRow?: React.FC<DataTableSummaryRowProps<ColumnID, ITEM>>,
}

export function DataTableContent<ColumnID extends string, ITEM extends TableNode>(props: DataTableContentProps<ColumnID, ITEM>) {
  const {loading, rows, summaryRow: SummaryRow} = props
  const content = loading
    ? <LoaderContainer />
    : rows.map(row => <DataTableContentRow key={row.id} row={row} {...props} />)

  return (
    <>
      <DataTableHeaderRow {...props} />
      <Body>
        {content}
        {SummaryRow && <SummaryRow rows={rows} columnIds={props.columns.map(x => x.id)} />}
      </Body>
    </>
  )
}

function LoaderContainer() {
  return (
    <div className='flex justify-center items-center w-full h-full grow'>
      <Loader />
    </div>
  )
}